import { memo } from "react";

import Img from "~/components/common/img";

import styles from "./index.module.scss";

type Position = {
  [key in "top" | "left" | "rotation" | "zIndex"]: number | undefined | null;
};

type Props = {
  src: string;
  alt?: string;
  caption?: string;
  selected: boolean;
  position: Position;
  handleImageClick: () => void;
};

const CultureImage = ({
  src,
  alt,
  selected,
  position,
  handleImageClick,
}: Props) => {
  // checks if the position is invalid by checking if one of the values is null or undefined
  const invalidPosition = Object.values(position).some(
    (val) => val === undefined || val === null
  );

  return (
    <Img
      src={src}
      alt={alt ?? ""}
      containerProps={{
        className: [styles.img, !selected ? styles.notSelected : null].join(
          " "
        ),
        style: {
          display: invalidPosition ? "none" : undefined,
          top: `${position.top ? position.top / 1.4 : 0}%`,
          left: `${position.left ? position.left / 1.4 : 0}%`,
          transform: `rotate(${position.rotation}deg)`,
          zIndex: `${position.zIndex}`,
        },
        onClick: handleImageClick,
      }}
    />
  );
};

export default memo(CultureImage);
